import { render, staticRenderFns } from "./checklist-component.vue?vue&type=template&id=5a8c23a9"
import script from "./checklist-component.vue?vue&type=script&lang=js"
export * from "./checklist-component.vue?vue&type=script&lang=js"
import style0 from "./checklist-component.vue?vue&type=style&index=0&id=5a8c23a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports